import React, { useState, useEffect, useRef } from 'react';
import { getDataWithComp, getData } from '../../../../utils/SamuiUtils';
import Datetime from "react-datetime";
import moment from "moment";
import "moment/locale/th"; // เพิ่มบรรทัดนี้
moment.locale("th");

import Swal from 'sweetalert2';
import { formatDateOnChange, formatThaiDateUi } from '../../../../utils/DateUtils';
const SERVICE_RECORD_FIELDS_TEMPLATE = (employeeOptions, serviceTypeOptions) => ([
  {
    section: '',
    fields: [
      { name: 'desc', label: 'รายละเอียดการเข้าบริการ', type: 'textarea', rows: 6, required: true },
    ]
  },
  {
    section: '',
    fields: [
      { name: 'detail', label: 'รายละเอียดการปฎิบัติงาน', type: 'textarea', rows: 6, required: true },
    ]
  },
  {
    section: '',
    fields: [
      { name: 'serviceDate', label: 'วันที่ให้บริการ', type: 'date' },
      { name: 'nextAppointment', label: 'นัดครั้งต่อไป', type: 'date' },
      {
        name: 'status', label: 'สถานะ', type: 'select', options: [
          { value: '1', label: 'รอเข้าพบ' },
          { value: '2', label: 'Checkin' },
          { value: '3', label: 'เลื่อนนัด' },
          { value: '4', label: 'ปิด Job' },
          { value: '13', label: 'ยกเลิก' },
        ]
      },
      {
        name: 'employee',
        label: 'พนักงานที่ให้บริการ',
        type: 'employee-select',
        options: employeeOptions || [],
        required: true
      },
      {
        name: 'serviceType',
        label: 'ประเภทการให้บริการ',
        type: 'select',
        options: serviceTypeOptions || [],
        required: true
      }
    ]
  },
  {
    section: '',
    fields: [
      { name: 'inquiryDate', label: 'วันที่สอบถาม', type: 'date' },
      {
        name: 'behavior', label: 'กิริยา/มารยาท', type: 'select', options: [
          { value: '5', label: 'ดีมาก' },
          { value: '4', label: 'ดี' },
          { value: '3', label: 'พอใช้' },
          { value: '2', label: 'ควรปรับปรุง' },
          { value: '1', label: 'ไม่ดี' },
        ]
      },
      {
        name: 'productOK', label: 'สินค้าถูกต้อง', type: 'select', options: [
          { value: '1', label: 'ถูกต้อง' },
          { value: '0', label: 'ไม่ถูกต้อง' },
        ]
      },
      {
        name: 'cleanliness', label: 'ความสะอาด', type: 'select', options: [
          { value: '5', label: 'ดีมาก' },
          { value: '4', label: 'ดี' },
          { value: '3', label: 'พอใช้' },
          { value: '2', label: 'ควรปรับปรุง' },
          { value: '1', label: 'ไม่ดี' },
        ]
      },
      {
        name: 'duration',
        label: 'ระยะเวลาการทำงาน',
        type: 'select',
        options: [
          { value: '8', label: '30 นาที' },
          { value: '7', label: '1 ชั่วโมง 30 นาที' },
          { value: '6', label: '2 ชั่วโมง' },
          { value: '5', label: '2 ชั่วโมง 30 นาที' },
          { value: '4', label: '3 ชั่วโมง' },
          { value: '3', label: '3 ชั่วโมง 30 นาที' },
          { value: '2', label: '4 ชั่วโมง' },
          { value: '1', label: 'มากกว่า 4 ชั่วโมง' },
        ]
      },
      { name: 'improvement', label: 'ข้อควรปรับปรุง', type: 'textarea', rows: 6 },
    ]
  }
]);

const EmployeeSelect = ({ name, value, onChange, options }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const dropdownRef = useRef(null);

  const selectedEmployee = options.find(emp => emp.value === value);

  const filteredOptions = options.filter(emp =>
    emp.label.toLowerCase().includes(searchTerm.toLowerCase())
  );

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);
  const handleSelect = (option) => {
    onChange({ target: { name, value: option } }); // ส่งทั้ง option object กลับ
    setIsOpen(false);
    setSearchTerm('');
  };



  const handleClear = () => {
    onChange({ target: { name, value: '' } });
    setSearchTerm('');
  };

  return (
    <div className="position-relative" ref={dropdownRef}>
      <div className="input-group">
        <input
          type="text"
          className="form-control"
          value={selectedEmployee ? selectedEmployee.label : ''}
          placeholder="-- เลือกพนักงาน --"
          readOnly
        />
        <button
          type="button"
          className="btn btn-outline-secondary"
          onClick={() => setIsOpen(!isOpen)}
        >
          <i className="fas fa-search"></i>
        </button>
        {selectedEmployee && (
          <button
            type="button"
            className="btn btn-outline-secondary"
            onClick={handleClear}
          >
            <i className="fas fa-times"></i>
          </button>
        )}
      </div>

      {isOpen && (
        <div className="dropdown-menu show position-absolute w-100" style={{ zIndex: 1050, maxHeight: '300px', overflowY: 'auto' }}>
          <div className="p-2">
            <input
              type="text"
              className="form-control form-control-sm"
              placeholder="ค้นหาพนักงาน..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              autoFocus
            />
          </div>
          <div className="dropdown-divider"></div>
          {filteredOptions.length > 0 ? (
            filteredOptions.map(option => (
              <button
                key={option.value}
                type="button"
                className={`dropdown-item ${value === option.value ? 'active' : ''}`}
                onClick={() => handleSelect(option)}
              >
                {option.label}
              </button>
            ))
          ) : (
            <div className="dropdown-item-text text-muted">
              ไม่พบพนักงานที่ค้นหา
            </div>
          )}
        </div>
      )}
    </div>
  );
};

const ServiceRecordModal = ({ record, onSave, onClose }) => {
  const [data, setData] = useState({
    desc: '',
    detail: '',
    nextAppointment: new Date().toISOString().split('T')[0],
    inquiryDate: null,
    behavior: '',
    productOK: '',
    cleanliness: '',
    duration: '',
    improvement: '',
    serviceDate: new Date().toISOString().split('T')[0],
    status: '',
    employee: '',
  });
  const [employeeOptions, setEmployeeOptions] = useState([]);
  const [serviceTypeOptions, setServiceTypeOptions] = useState([]);

  useEffect(() => {
    if (!record) return;

    const matchedEmployee = employeeOptions.find(
      opt => opt.value.id === record.employee?.id || opt.value.id === record.employee?.value?.id
    );

    const matchedServiceType = serviceTypeOptions.find(
      opt => opt.value.id === record.serviceType?.value?.id
    );
    setData({
      ...record,
      employee: matchedEmployee || null,
      serviceType: matchedServiceType || null
    });
  }, [record, employeeOptions, serviceTypeOptions]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [employeeRes, serviceRes] = await Promise.all([
          getDataWithComp('tb_set_employee', 'Order By Emp_Code ASC'),
          getData('Tb_Set_Service', "srv_use = 'Y'")
        ]);

        const employeeOptions = employeeRes.map(emp => ({
          value: { id: emp.Emp_Id, name: emp.Emp_Name },
          label: `${emp.Emp_Code} - ${emp.Emp_Prefix} ${emp.Emp_Name} (${emp.Emp_Position_Detail})`
        }));

        const serviceOptions = serviceRes.map(item => ({
          value: { id: item.srv_id, name: item.srv_name },
          label: item.srv_name
        }));


        setEmployeeOptions(employeeOptions);
        setServiceTypeOptions(serviceOptions);

      } catch (err) {
        console.error("โหลดข้อมูลล้มเหลว", err);
      }
    };

    fetchData();
  }, []);


  const handleChange = (e) => {
    const { name, value } = e.target;
    if (typeof value === 'object' && value !== null) {
      setData(prev => ({ ...prev, [name]: value }));

    } else {
      try {
        const parsed = JSON.parse(value);
        setData(prev => ({ ...prev, [name]: parsed }));
      } catch {
        setData(prev => ({ ...prev, [name]: value }));

      }
    }
  };

  const handleSubmit = (e) => {
    if (!data.employee) {
      Swal.fire({
        icon: 'warning',
        title: 'กรุณาเลือกพนักงานที่ให้บริการ',
        text: 'คุณต้องเลือกพนักงานก่อนบันทึกรายการบริการ',
      });
      return;
    }
    if (!data.serviceType) {
      Swal.fire({
        icon: 'warning',
        title: 'กรุณาเลือกประเภทการให้บริการ',
        text: 'คุณต้องเลือกประเภทการให้บริการก่อนบันทึกรายการบริการ',
      });
      return;
    }
    e.preventDefault();
    onSave(data);
  };

  const FIELDS = SERVICE_RECORD_FIELDS_TEMPLATE(employeeOptions, serviceTypeOptions);

  const renderField = (field) => {
    if (field.type === 'employee-select') {
      return (
        <EmployeeSelect
          name={field.name}
          value={data[field.name]?.value || ''}
          onChange={handleChange}
          options={field.options}
        />
      );
    }

    if (field.type === 'textarea') {
      return (
        <textarea
          className="form-control w-100"
          style={{
            width: "100%",
            marginTop: "4px",
            lineHeight: "1.6",
          }}
          name={field.name}
          rows={field.rows || 3}
          value={data[field.name] || ''}
          onChange={handleChange}
          required={field.required}
        />


      );
    }

    if (field.type === 'select') {
      return (
        <select
          className="form-select"
          name={field.name}
          value={JSON.stringify(data[field.name] || '')}
          onChange={handleChange}
        >
          <option value="">-- เลือก --</option>
          {field.options.map(opt => (
            <option key={opt.label} value={JSON.stringify(opt)}>
              {opt.label}
            </option>
          ))}
        </select>
      );
    }
    if (field.type === 'date') {
      return (
        <Datetime
          name={field.name}
          value={
            data[field.name]
              ? moment(data[field.name], 'YYYY-MM-DD')
              : null
          }
          onChange={(date) => {
            if (!moment.isMoment(date)) return;
            const toGregorian = date.format('YYYY-MM-DD');
            handleChange({ target: { name: field.name, value: toGregorian } });
          }}
          dateFormat="DD/MM/YYYY"
          timeFormat={false}
          inputProps={{
            readOnly: true,
            value:
              data[field.name]
                ? moment(data[field.name], 'YYYY-MM-DD')
                  .clone()
                  .add(543, 'year')
                  .format('DD/MM/YYYY')
                : ''
          }}
        />



      );
    }
    return (
      <input
        type={field.type || 'text'}
        className="form-control"
        name={field.name}
        value={data[field.name] || ''}
        onChange={handleChange}
        required={field.required}
      />
    );
  }
  return (
    <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div>
            <div className="modal-header">
              <h5 className="modal-title">
                <i className="fas fa-wrench me-2"></i>
                {record?.id ? 'แก้ไขรายละเอียดบริการ' : 'เพิ่มรายการบริการ'}
              </h5>
              <button type="button" className="btn-close" onClick={onClose}></button>
            </div>

            <div className="modal-body">
              {FIELDS.map((section, idx) => (
                <div className="mb-3" key={idx}>
                  <hr />
                  {section.section && <h3 className="mb-2">{section.section}</h3>}
                  <div className="row">
                    {section.fields.map(field => (
                      <div className={`${field.type === 'textarea' ? 'col-12' : 'col-md-6'} mb-3`} key={field.name}>
                        <label className="form-label">{field.label}</label>
                        {renderField(field)}
                      </div>
                    ))}

                  </div>
                </div>
              ))}
            </div>

            <div className="modal-footer">
              <button type="button" className="btn btn-danger" onClick={
                () => {
                  Swal.fire({
                    title: 'ยืนยันการยกเลิก?',
                    text: "คุณแน่ใจหรือไม่ว่าต้องการยกเลิกการแก้ไขรายการนี้?",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#d33',
                    cancelButtonColor: '#3085d6',
                    confirmButtonText: 'ยืนยัน',
                    cancelButtonText: 'ยกเลิก'
                  }).then((result) => {
                    if (result.isConfirmed) {
                      onClose();
                    }
                  }
                  );
                }
              }>
                ยกเลิก
              </button>
              <button type="button" className="btn btn-primary" onClick={handleSubmit}>
                บันทึก
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceRecordModal;